import { getBackgroundLayerProps } from '@/utils/layer-kit';
import { StretchOptionType } from '@/version-types';
import type { IBackgroundLayerCreateProps } from './type';

const createBase = (color: string, url = '', stretchOption = StretchOptionType.cover) => {
    return {
        backgroundColor: color,
        url,
        naturalWidth: 0,
        naturalHeight: 0,
        backgroundGradient: null,
        imageTransform: {
            offsetX: 0,
            offsetY: 0,
            rotate: 0,
            scale: 1,
            flipH: false,
            flipV: false,
            widthRatio: 1,
            heightRatio: 1,
        },
        stretchOption,
    };
};

export const createBackgroundLayer = (options: IBackgroundLayerCreateProps) => {
    return getBackgroundLayerProps({
        width: options.width,
        height: options.height,
        data: createBase(options.backgroundColor),
    });
};
